import React, {useState} from "react";
import signPer from "../../../Assets/Signup/signPer.svg";
import { AiOutlineClose } from "react-icons/ai";
import style from "../Signup/signup.module.css";
const Signup = ({ setShowLogin,setShowSignup,SignupUser }) => {

  const [name, setName] = useState(false)
  const [email, setEmail] = useState(false)
  const [password, setPassword] = useState(false)


  return (
    <>
      <div className={`${style.display}`}>
        <div className={`${style.signUp} p-6`}>
          <AiOutlineClose className={`${style.cancel} text-lg `} onClick={()=>{setShowSignup(false)}}  />
          <form className={`flex flex-col items-center justify-center gap-6`}>
            <div className="pt-8">
              <p className={`${style.Welcome} text-[#1A3168]`}>
                Welcome to Edflix.
              </p>
            </div>
            <div>
              <img src={signPer} alt="User" className={`${style.userImg}`} />
              <p className={`${style.ImgCaption} text-[#1A3168] p-1`}>
                Add a profile picture
              </p>
            </div>
            <div>
              <div>
                <input
                  type="text"
                  placeholder="Full Name"
                  className={`${style.RecBg} `}
                  onChange={(e)=>{setName(e.target.value)}}
                />
              </div>
              <div>
                <input
                  type="text"
                  placeholder="Email Id"
                  className={`${style.RecBg} `}
                  onChange={(e)=>{setEmail(e.target.value)}}
                />
              </div>
              <div>
                <input
                  type="text"
                  placeholder="Password"
                  className={`${style.RecBg} `}
                  onChange={(e)=>{setPassword(e.target.value)}}
                />
              </div>
            </div>
            <p className={`${style.muted} text-[#1A3168] -mt-10`}>
              By signing up I agree to all the Terms and conditions
            </p>

            <div>
              <button
                type="submit"
                className={`${style.SignUpBtn} text-[#1A3168] `}
                onClick={(e)=>{SignupUser(name,email,password,e)}}
              >
                Sign Up
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Signup;
